export const MOCK_USERS_INTERNES = [
  {
    id: 'ui-001', prenom: 'Koné', nom: 'Mamadou', initiales: 'KM',
    email: 'kone.mamadou@bet.ci', role: 'admin_manager',
    description: 'Manager BET · Pilotage global',
    est_actif: true, deux_facteurs: true,
    date_creation: '2025-01-10', derniere_connexion: '2026-05-30 08:15',
    acces_elearning: true, source: 'bet_system',
    permissions: ['all'],
  },
  {
    id: 'ui-002', prenom: 'Traoré', nom: 'Aminata', initiales: 'TA',
    email: 'traore.aminata@bet.ci', role: 'admin_superviseur',
    description: 'Superviseur · Suivi qualité',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-02-05', derniere_connexion: '2026-05-29 14:22',
    acces_elearning: true, source: 'bet_system',
    permissions: ['read_all', 'evaluate', 'replace'],
  },
  {
    id: 'ui-003', prenom: 'Diabaté', nom: 'Ibrahim', initiales: 'DI',
    email: 'diabate.ibrahim@bet.ci', role: 'admin_placement',
    description: 'Agent Placement · Tests de niveau',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-02-20', derniere_connexion: '2026-05-28 10:05',
    acces_elearning: true, source: 'bet_system',
    permissions: ['tests', 'affectation'],
  },
  {
    id: 'ui-004', prenom: 'Coulibaly', nom: 'Fatou', initiales: 'CF',
    email: 'coulibaly.fatou@bet.ci', role: 'admin_onboarding',
    description: 'Agent Onboarding · Classes & contenus',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-03-01', derniere_connexion: '2026-05-30 09:30',
    acces_elearning: true, source: 'bet_system',
    permissions: ['classes', 'contenus', 'apprenants_create'],
  },
  {
    id: 'ui-005', prenom: 'Ouattara', nom: 'Seydou', initiales: 'OS',
    email: 'ouattara.seydou@bet.ci', role: 'admin_elearning',
    description: 'Assistant E-Learning · Suivi programme',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-03-15', derniere_connexion: '2026-05-27 16:40',
    acces_elearning: true, source: 'bet_system',
    permissions: ['programme', 'read_apprenants'],
  },
  {
    id: 'ui-006', prenom: 'Konaté', nom: 'Bintou', initiales: 'KB',
    email: 'konate.bintou@bet.ci', role: 'admin_customer_care',
    description: 'Customer Care · Support client',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-03-20', derniere_connexion: '2026-05-30 07:55',
    acces_elearning: true, source: 'bet_system',
    permissions: ['tickets', 'messaging', 'read_clients'],
  },
  {
    id: 'ui-007', prenom: 'Diallo', nom: 'Ibrahima', initiales: 'DI',
    email: 'diallo.ibrahima@bet.ci', role: 'admin_manager',
    description: 'Manager BET · Administration',
    est_actif: true, deux_facteurs: true,
    date_creation: '2025-01-15', derniere_connexion: '2026-05-30 08:15',
    acces_elearning: true, source: 'bet_system',
    permissions: ['all'],
  },
  {
    id: 'ui-008', prenom: 'Bamba', nom: 'Mariam', initiales: 'BM',
    email: 'bamba.mariam@bet.ci', role: 'admin_superviseur',
    description: 'Superviseure · Qualité pédagogique',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-04-01', derniere_connexion: '2026-05-26 11:30',
    acces_elearning: true, source: 'bet_system',
    permissions: ['read_all', 'evaluate'],
  },
  {
    id: 'ui-009', prenom: 'Touré', nom: 'Drissa', initiales: 'TD',
    email: 'toure.drissa@bet.ci', role: 'admin_placement',
    description: 'Agent Placement · Tests CECR',
    est_actif: false, deux_facteurs: false,
    date_creation: '2025-04-10', derniere_connexion: '2026-04-15 09:00',
    acces_elearning: true, source: 'bet_system',
    permissions: ['tests'],
  },
  {
    id: 'ui-010', prenom: 'Sanogo', nom: 'Adama', initiales: 'SA',
    email: 'sanogo.adama@bet.ci', role: 'admin_onboarding',
    description: 'Agent Onboarding · Inscription',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-04-15', derniere_connexion: '2026-05-29 13:10',
    acces_elearning: true, source: 'bet_system',
    permissions: ['classes', 'apprenants_create'],
  },
  {
    id: 'ui-011', prenom: 'Kouyaté', nom: 'Sali', initiales: 'KS',
    email: 'kouyate.sali@bet.ci', role: 'admin_elearning',
    description: 'Assistante E-Learning · Contenus',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-05-01', derniere_connexion: '2026-05-28 15:20',
    acces_elearning: true, source: 'bet_system',
    permissions: ['programme', 'contenus'],
  },
  {
    id: 'ui-012', prenom: 'Bah', nom: 'Aïssatou', initiales: 'BA',
    email: 'bah.aissatou@bet.ci', role: 'admin_customer_care',
    description: 'Customer Care · Relation client',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-05-10', derniere_connexion: '2026-05-30 08:40',
    acces_elearning: true, source: 'bet_system',
    permissions: ['tickets', 'messaging'],
  },
  {
    id: 'ui-013', prenom: 'Kamara', nom: 'Lamine', initiales: 'KL',
    email: 'kamara.lamine@bet.ci', role: 'admin_superviseur',
    description: 'Superviseur · Évaluations',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-05-20', derniere_connexion: '2026-05-25 17:00',
    acces_elearning: true, source: 'bet_system',
    permissions: ['read_all', 'evaluate', 'replace'],
  },
  {
    id: 'ui-014', prenom: 'Doumbia', nom: 'Kadiatou', initiales: 'DK',
    email: 'doumbia.kadiatou@bet.ci', role: 'admin_placement',
    description: 'Agente Placement',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-06-01', derniere_connexion: '2026-05-29 09:45',
    acces_elearning: true, source: 'bet_system',
    permissions: ['tests', 'affectation'],
  },
  {
    id: 'ui-015', prenom: 'Fofana', nom: 'Moussa', initiales: 'FM',
    email: 'fofana.moussa@bet.ci', role: 'admin_onboarding',
    description: 'Agent Onboarding · Contenus',
    est_actif: false, deux_facteurs: false,
    date_creation: '2025-06-10', derniere_connexion: '2026-03-20 12:00',
    acces_elearning: true, source: 'bet_system',
    permissions: ['contenus'],
  },
  {
    id: 'ui-016', prenom: 'Sow', nom: 'Hawa', initiales: 'SH',
    email: 'sow.hawa@bet.ci', role: 'admin_elearning',
    description: 'Assistante E-Learning',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-06-15', derniere_connexion: '2026-05-28 14:50',
    acces_elearning: true, source: 'bet_system',
    permissions: ['programme'],
  },
  {
    id: 'ui-017', prenom: 'Coulibaly', nom: 'Cheick', initiales: 'CC',
    email: 'coulibaly.cheick@bet.ci', role: 'admin_customer_care',
    description: 'Customer Care',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-07-01', derniere_connexion: '2026-05-30 07:30',
    acces_elearning: true, source: 'bet_system',
    permissions: ['tickets'],
  },
  {
    id: 'ui-018', prenom: 'Keïta', nom: 'Salimata', initiales: 'KS',
    email: 'keita.salimata@bet.ci', role: 'admin_manager',
    description: 'Manager BET · RH & Finance',
    est_actif: true, deux_facteurs: true,
    date_creation: '2025-01-20', derniere_connexion: '2026-05-29 16:00',
    acces_elearning: true, source: 'bet_system',
    permissions: ['all'],
  },

  // ── Assistante Corporate ─────────────────────────────────────────────────────
  {
    id: 'ui-030', prenom: 'Koné', nom: 'Nadia', initiales: 'KN',
    email: 'commercial@bet.ci', role: 'admin_commercial',
    description: 'Assistante Corporate · Gestion entreprises clientes BET',
    est_actif: true, deux_facteurs: false,
    date_creation: '2026-01-10', derniere_connexion: '2026-06-07 09:15',
    acces_elearning: true, source: 'bet_system',
    permissions: ['voir_clients', 'creer_devis', 'suivi_pipeline', 'rapports_ca'],
  },

  // ── Professeurs ─────────────────────────────────────────────────────────────
  {
    id: 'ui-019', prenom: 'Dupont', nom: 'Marie', initiales: 'DM',
    email: 'marie.dupont@bet.ci', role: 'professeur_titulaire',
    description: 'Professeure titulaire · Groupes enfants & ados',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-01-12', derniere_connexion: '2026-05-30 08:00',
    acces_elearning: true, source: 'bet_system',
    permissions: ['animer_sessions', 'noter_apprenants', 'gerer_presences', 'acceder_contenus', 'voir_planning'],
  },
  {
    id: 'ui-020', prenom: 'Martin', nom: 'Pierre', initiales: 'MP',
    email: 'pierre.martin@bet.ci', role: 'professeur_titulaire',
    description: 'Professeur titulaire · Groupes adultes entreprises',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-02-01', derniere_connexion: '2026-05-29 17:30',
    acces_elearning: true, source: 'bet_system',
    permissions: ['animer_sessions', 'noter_apprenants', 'gerer_presences', 'acceder_contenus', 'voir_planning'],
  },
  {
    id: 'ui-021', prenom: 'Leclerc', nom: 'Sophie', initiales: 'LS',
    email: 'sophie.leclerc@bet.ci', role: 'professeur_titulaire',
    description: 'Professeure titulaire · Spécialiste Business English',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-03-10', derniere_connexion: '2026-05-28 14:00',
    acces_elearning: true, source: 'bet_system',
    permissions: ['animer_sessions', 'noter_apprenants', 'gerer_presences', 'acceder_contenus', 'voir_planning'],
  },
  {
    id: 'ui-022', prenom: 'Bernard', nom: 'Luc', initiales: 'BL',
    email: 'luc.bernard@bet.ci', role: 'professeur_remplacant',
    description: 'Professeur remplaçant · Disponible sur appel',
    est_actif: true, deux_facteurs: false,
    date_creation: '2025-05-15', derniere_connexion: '2026-05-20 09:00',
    acces_elearning: true, source: 'bet_system',
    permissions: ['animer_sessions', 'gerer_presences', 'acceder_contenus', 'voir_planning'],
  },
  {
    id: 'ui-023', prenom: 'Moreau', nom: 'Claire', initiales: 'MC',
    email: 'claire.moreau@bet.ci', role: 'professeur_remplacant',
    description: 'Professeure remplaçante · Disponible week-ends',
    est_actif: false, deux_facteurs: false,
    date_creation: '2025-06-20', derniere_connexion: '2026-04-10 10:00',
    acces_elearning: true, source: 'bet_system',
    permissions: ['animer_sessions', 'gerer_presences', 'voir_planning'],
  },
];

export const PERMISSIONS_MATRICE = [
  // Administration
  { id: 'read_all',          libelle: 'Lire tout',              categorie: 'Admin', roles: ['admin_manager'] },
  { id: 'write_all',         libelle: 'Modifier tout',          categorie: 'Admin', roles: ['admin_manager'] },
  { id: 'delete',            libelle: 'Supprimer',              categorie: 'Admin', roles: ['admin_manager'] },
  { id: 'droits_acces',      libelle: 'Gestion des droits',     categorie: 'Admin', roles: ['admin_manager'] },
  // Pédagogie
  { id: 'gestion_profs',     libelle: 'Gérer professeurs',      categorie: 'Pédagogie', roles: ['admin_manager', 'admin_superviseur'] },
  { id: 'evaluate',          libelle: 'Évaluer professeurs',    categorie: 'Pédagogie', roles: ['admin_superviseur'] },
  { id: 'replace',           libelle: 'Gérer remplacements',    categorie: 'Pédagogie', roles: ['admin_superviseur', 'admin_manager'] },
  { id: 'animer_sessions',   libelle: 'Animer des sessions',    categorie: 'Pédagogie', roles: ['professeur_titulaire', 'professeur_remplacant'] },
  { id: 'noter_apprenants',  libelle: 'Noter les apprenants',   categorie: 'Pédagogie', roles: ['professeur_titulaire'] },
  { id: 'gerer_presences',   libelle: 'Gérer les présences',    categorie: 'Pédagogie', roles: ['professeur_titulaire', 'professeur_remplacant'] },
  { id: 'acceder_contenus',  libelle: 'Accéder aux contenus',   categorie: 'Pédagogie', roles: ['professeur_titulaire', 'professeur_remplacant', 'admin_elearning', 'admin_onboarding'] },
  { id: 'voir_planning',     libelle: 'Voir le planning',       categorie: 'Pédagogie', roles: ['professeur_titulaire', 'professeur_remplacant', 'admin_superviseur', 'admin_manager'] },
  // Apprenants
  { id: 'tests',             libelle: 'Tests de niveau',        categorie: 'Apprenants', roles: ['admin_placement'] },
  { id: 'affectation',       libelle: 'Affecter apprenants',    categorie: 'Apprenants', roles: ['admin_placement', 'admin_manager'] },
  { id: 'classes',           libelle: 'Gérer classes',          categorie: 'Apprenants', roles: ['admin_onboarding', 'admin_manager'] },
  { id: 'programme',         libelle: 'Suivi programme',        categorie: 'Apprenants', roles: ['admin_elearning', 'admin_superviseur'] },
  { id: 'contenus',          libelle: 'Gérer contenus',         categorie: 'Apprenants', roles: ['admin_onboarding', 'admin_elearning'] },
  // Support & clients
  { id: 'tickets',           libelle: 'Tickets support',        categorie: 'Support', roles: ['admin_customer_care'] },
  { id: 'messaging',         libelle: 'Messagerie client',      categorie: 'Support', roles: ['admin_customer_care', 'admin_manager'] },
  { id: 'read_clients',      libelle: 'Voir clients',           categorie: 'Support', roles: ['admin_customer_care', 'admin_manager', 'admin_superviseur', 'admin_commercial'] },
  // Commercial
  { id: 'voir_clients',         libelle: 'Voir entreprises clientes',        categorie: 'Commercial', roles: ['admin_commercial', 'admin_manager'] },
  { id: 'creer_devis',          libelle: 'Créer devis & contrats',           categorie: 'Commercial', roles: ['admin_commercial', 'admin_manager'] },
  { id: 'suivi_pipeline',       libelle: 'Suivi pipeline commercial',        categorie: 'Commercial', roles: ['admin_commercial', 'admin_manager'] },
  { id: 'rapports_ca',          libelle: "Rapports chiffre d'affaires",      categorie: 'Commercial', roles: ['admin_commercial', 'admin_manager', 'admin_comptable'] },
  { id: 'modifier_entreprises', libelle: 'Modifier entreprises clientes',    categorie: 'Commercial', roles: ['admin_elearning', 'admin_commercial'] },
  { id: 'saisir_paiements',     libelle: 'Saisir paiements / versements',    categorie: 'Commercial', roles: ['admin_elearning', 'admin_commercial'] },
];
